"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventHub = new Vue();
var eventMixin = {
  data: function data() {
    return {
      eventHub: eventHub
    };
  }
};
var lawyerHub = new Vue();
var lawyerMixin = {
  data: function data() {
    return {
      lawyerHub: lawyerHub,
      thumbnailLoading: false,
      status: {
        label: 'status',
        ALREADY_REMOVED: -1,
        REMOVED: 0,
        CREATED: 1,
        CHANGED: 2
      },
      statusMethods: {
        REMOVED: 'delete',
        CREATED: 'post',
        CHANGED: 'patch'
      },
      networksOptions: [{
        label: 'Linkedin',
        url: '',
        name: 'linkedin',
        network: 1
      }, {
        label: 'Facebook',
        url: '',
        name: 'facebook',
        network: 2
      }, {
        label: 'Twitter',
        url: '',
        name: 'twitter',
        network: 3
      }, {
        label: 'Instagram',
        url: '',
        name: 'instagram',
        network: 4
      }, {
        label: 'Youtube',
        url: '',
        name: 'youtube',
        network: 5
      }, {
        label: 'Google Plus',
        url: '',
        name: 'google',
        network: 6
      }],
      positionsOptions: [{
        id: "",
        name: 'Je suis...'
      }, {
        id: 0,
        name: 'Avocat associé'
      }, {
        id: 1,
        name: 'Avocat collaborateur'
      }, {
        id: 2,
        name: 'Avocat honoraires'
      }, {
        id: 3,
        name: 'Autre'
      }]
    };
  },
  methods: {
    //UTILS
    checkStatus: function checkStatus(obj, checkId) {
      if (checkId && this.isRemoved(obj)) {
        return obj.id.toString().indexOf('_') == -1;
      }

      return obj.hasOwnProperty(this.status.label) && !this.isAlreadyRemoved(obj);
    },
    getStatus: function getStatus(obj) {
      return obj[this.status.label];
    },
    getStatusLabel: function getStatusLabel(obj) {
      var values = Object.values(this.status),
          labels = Object.keys(this.status);
      return labels[values.indexOf(obj[this.status.label])];
    },
    isCreated: function isCreated(obj) {
      return this.getStatus(obj) == this.status.CREATED;
    },
    isChanged: function isChanged(obj) {
      return this.getStatus(obj) == this.status.CHANGED;
    },
    isRemoved: function isRemoved(obj) {
      return this.getStatus(obj) == this.status.REMOVED;
    },
    isAlreadyRemoved: function isAlreadyRemoved(obj) {
      return this.getStatus(obj) == this.status.ALREADY_REMOVED;
    },
    setStatus: function setStatus(condition, obj) {
      obj[this.status.label] = condition ? this.status.CHANGED : this.status.CREATED;
      return obj;
    },
    setRemoved: function setRemoved(obj) {
      obj[this.status.label] = this.status.REMOVED;
      return obj;
    },
    setAlreadyRemoved: function setAlreadyRemoved(obj) {
      obj[this.status.label] = this.status.ALREADY_REMOVED;
      return obj;
    },
    setCreated: function setCreated(obj) {
      obj[this.status.label] = this.status.CREATED;
      return obj;
    },
    setChanged: function setChanged(obj) {
      obj[this.status.label] = this.status.CHANGED;
      return obj;
    },
    randomId: function randomId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    },
    //THUMBNAIL
    setThumbnailToLawyer: function setThumbnailToLawyer(image, lawyer) {
      var _this = this;

      lawyer.image = image;
      this.put('lawyers', lawyer, function (response) {
        _this.thumbnailLoading = false;

        _this.lawyerHub.$emit('change', 'thumbnail', response.thumbnail);

        var images = document.querySelectorAll('.js-lawyer-image');
        images.forEach(function (i) {
          return i.style.backgroundImage = 'url(' + response.thumbnail + ')';
        });
      });
    },
    saveThumbnail: function saveThumbnail(event, lawyer) {
      var _this2 = this;

      if (event && lawyer) {
        var file = event.target.files[0],
            formData = new FormData();
        formData.append('image', file);
        formData.append('attachment', file);
        formData.append('csrfmiddlewaretoken', this.$refs.thumbnailCsrf.value);
        $.ajax({
          url: '/api/v1/medias',
          type: 'POST',
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function beforeSend() {
            _this2.thumbnailLoading = true;
          },
          success: function success(response) {
            _this2.setThumbnailToLawyer(response.id, lawyer);
          },
          error: function error(_error) {
            return _this2.eventHub.$emit("alert:error:open");
          }
        });
      }
    },
    //ERRORS
    verifyErrors: function verifyErrors(errors, data) {
      if (errors.hasOwnProperty('degree')) {
        this.lawyerHub.$emit("errors:degrees", errors);
      }
    },
    setError: function setError(endpoint, error, data) {
      var _this3 = this;

      if (error.status == 400) {
        this.verifyErrors(error.responseJSON, data);

        if (endpoint == 'lawyers') {
          Object.keys(error.responseJSON).forEach(function (err) {
            _this3.lawyerHub.$emit("errors:".concat(err), error.responseJSON[err], data);

            _this3.lawyerHub.$emit("error:".concat(err, ":").concat(err), error.responseJSON[err], data);
          });
        }

        this.lawyerHub.$emit("errors:".concat(endpoint), error.responseJSON, data);
      } else {
        this.eventHub.$emit("alert:error:open");
      }
    },
    //API
    saveCallback: function saveCallback(arr, callback) {
      if (arr.length) {
        this[callback]();
      }
    },
    getSocialLabel: function getSocialLabel(network) {
      var found = this.networksOptions.filter(function (n) {
        return n.network == network;
      });
      return found.length ? found[0].label : '';
    },
    getEndpointId: function getEndpointId(endpoint, r) {
      return endpoint == "social_networks" ? r.network : r.id;
    },
    getEndpointObj: function getEndpointObj(endpoint, method, r, res) {
      var obj = method == 'delete' ? {
        id: this.randomId()
      } : res;

      if (endpoint == "social_networks") {
        delete obj[this.status.label];

        if (method == 'delete') {
          obj = {
            network: r.network,
            url: ''
          };
        }

        obj = _objectSpread({}, obj, {
          label: this.getSocialLabel(r.network)
        });
      }

      return obj;
    },
    retrieve: function retrieve(endpoint, id, callback) {
      var _this4 = this;

      $.ajax({
        url: '/api/v1/lawyers/' + id,
        headers: {
          'Accept-Language': languageCode
        },
        method: 'GET',
        success: function success(response) {
          if (callback) {
            callback(response);
          }
        },
        error: function error(_error2) {
          return _this4.eventHub.$emit("alert:error:open");
        }
      });
    },
    list: function list(endpoint, id, callback) {
      var _this5 = this;

      var data = {};

      if (id) {
        data['lawyer'] = id;
      }

      $.ajax({
        url: '/api/v1/' + endpoint,
        data: data,
        headers: {
          'Accept-Language': languageCode
        },
        method: 'GET',
        success: function success(response) {
          if (callback) {
            callback(response.results);
          }
        },
        error: function error(_error3) {
          return _this5.eventHub.$emit("alert:error:open");
        }
      });
    },
    delete: function _delete(endpoint, data, callback, callbackError) {
      var _this6 = this;

      $.ajax({
        url: '/api/v1/' + endpoint + '/' + data.id,
        method: 'DELETE',
        success: function success(response) {
          if (callback) {
            callback(response);
          }
        },
        error: function error(_error4) {
          if (callbackError) {
            callbackError(_error4);
          }

          _this6.setError(endpoint, _error4, data);
        }
      });
    },
    put: function put(endpoint, data, callback, callbackError) {
      var _this7 = this;

      $.ajax({
        url: '/api/v1/' + endpoint + '/' + data.id,
        data: data,
        headers: {
          'Accept-Language': languageCode
        },
        method: 'PUT',
        success: function success(response) {
          if (callback) {
            callback(response);
          }
        },
        error: function error(_error5) {
          if (callbackError) {
            callbackError(_error5);
          }

          _this7.setError(endpoint, _error5, data);
        }
      });
    },
    patch: function patch(endpoint, data, callback, callbackError) {
      var _this8 = this;

      $.ajax({
        url: '/api/v1/' + endpoint + '/' + data.id,
        data: data,
        headers: {
          'Accept-Language': languageCode
        },
        method: 'PATCH',
        success: function success(response) {
          if (callback) {
            callback(response);
          }
        },
        error: function error(_error6) {
          if (callbackError) {
            callbackError(_error6);
          }

          _this8.setError(endpoint, _error6, data);
        }
      });
    },
    post: function post(endpoint, data, callback, callbackError) {
      var _this9 = this;

      $.ajax({
        url: '/api/v1/' + endpoint,
        data: data,
        headers: {
          'Accept-Language': languageCode
        },
        method: 'POST',
        success: function success(response) {
          if (callback) {
            callback(response);
          }
        },
        error: function error(_error7) {
          if (callbackError) {
            callbackError(_error7);
          }

          _this9.setError(endpoint, _error7, data);
        }
      });
    },
    saveList: function saveList(endpoint, list, lawyerId, callback) {
      var _this10 = this;

      var listErrors = [];
      list.forEach(function (r, i) {
        //get method from object status
        var method = _this10.statusMethods[_this10.getStatusLabel(r)];

        if (method) {
          if (method == 'post') {
            r['lawyer'] = lawyerId;
          }

          _this10[method](endpoint, r, function (res) {
            listErrors[i] = []; //emit methodRow to change list in repeaters with new values

            _this10.lawyerHub.$emit("".concat(method, "Row:").concat(endpoint), _this10.getEndpointId(endpoint, r), _this10.getEndpointObj(endpoint, method, r, res));
          }, function (err) {
            if (err.status == 400) {
              var error = {};
              error[_this10.getEndpointId(endpoint, r)] = err.responseJSON;
              listErrors[i] = error;
            }
          });
        }
      }); //Interval to verify if all rows are post

      var verifySuccess = setInterval(function () {
        if (listErrors.length == list.length || !callback) {
          //add callback values to verify if we had errors
          var success = listErrors.reduce(function (prev, curr) {
            return prev.concat(curr);
          }, []);
          clearInterval(verifySuccess);

          if (callback) {
            callback(listErrors);
          }
        }
      }, 1000);
    }
  }
};
Vue.component('alert', {
  delimiters: ['[[', ']]'],
  mixins: [eventMixin],
  props: ['name', 'classes', 'delay'],
  data: function data() {
    return {
      opened: false,
      defaultDelay: 3000,
      defaultClasses: 'notification is-danger',
      openedClass: 'show'
    };
  },
  mounted: function mounted() {
    var _this11 = this;

    this.eventHub.$on("alert:".concat(this.name, ":close"), function () {
      _this11.opened = false;
    });
    this.eventHub.$on("alert:".concat(this.name, ":open"), function (data) {
      _this11.opened = true; //close

      setTimeout(function () {
        _this11.eventHub.$emit("alert:".concat(_this11.name, ":close"));
      }, _this11.time);
    });
  },
  computed: {
    time: function time() {
      return this.delay ? this.delay : this.defaultDelay;
    },
    fullClasses: function fullClasses() {
      var openedClasses = this.opened ? ' ' + this.openedClass : '';
      return (this.classes ? this.classes : this.defaultClasses) + openedClasses;
    }
  },
  template: "<div :class=\"fullClasses\">\n  <slot name=\"body\"></slot>\n</div>\n"
});
Vue.component('common-input', {
  delimiters: ['[[', ']]'],
  mixins: [eventMixin],
  template: "<div class=\"form-group\" :class=\"{'has-error': errors}\">\n    <label class=\"Label\"\n    :for=\"id\"\n    v-if=\"label\">\n        [[labelRequired]]\n    </label>\n    <input\n    class=\"Input\"\n    :type=\"type\"\n    :name=\"name\"\n    :id=\"id\"\n    :value=\"value\"\n    :placeholder=\"placeholder\"\n    @input=\"change\"\n    autocomplete=\"off\"\n    v-if=\"type != 'date' && type != 'time'\">\n    <input\n    class=\"Input\"\n    :name=\"name\"\n    :id=\"id\"\n    :value=\"value\"\n    :placeholder=\"placeholder\"\n    @input=\"change\"\n    autocomplete=\"off\"\n    v-else\n    ref=\"input\">\n    <!--<p\n    class=\"error\"\n    v-if=\"errors\">\n    [[ errors | join ]]\n    </p>-->\n</div>\n",
  props: ['id', 'name', 'errors', 'value', 'label', 'required', 'type', 'placeholder'],
  methods: {
    change: function change(e) {
      this.$emit('input', e.target.value);
    },
    initTimePicker: function initTimePicker() {
      var that = this;
      $(this.$refs.input).timepicker({
        timeFormat: 'HH:mm',
        dropdown: false,
        change: function change(time) {
          // the input field
          var element = $(this),
              text;
          var timepicker = element.timepicker();
          text = 'Selected time is: ' + timepicker.format(time); //that.$emit('input', time)

          console.log(time);
        }
      });
    },
    initDatePicker: function initDatePicker() {
      var that = this;
      $(this.$refs.input).datepicker({
        dateFormat: "dd/mm/yy",
        onSelect: function onSelect(date) {
          console.log(date);
          that.$emit('input', date);
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.type == "date") {
      this.initDatePicker();
    } else if (this.type == "time") {
      this.initTimePicker();
    }
  },
  computed: {
    labelRequired: function labelRequired() {
      return this.required ? this.label + " *" : this.label;
    }
  }
});
Vue.component('common-select', {
  delimiters: ['[[', ']]'],
  mixins: [eventMixin],
  template: "",
  props: ['id', 'name', 'errors', 'value', 'label', 'required', 'options'],
  methods: {
    change: function change(e) {
      this.$emit('input', e.target.value);
    }
  },
  computed: {
    labelRequired: function labelRequired() {
      return this.required ? this.label + " *" : this.label;
    }
  }
});
Vue.component('dropdown', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin, eventMixin],
  template: "<div class=\"Dropsel--container z2 no-option-0\" :class=\"{'is-front': active }\">\n  <!--<select\n  class=\"Input Dropsel--select\"\n  @change=\"setValue($event)\"\n  v-on:blur=\"toggle($event)\"\n  v-on:focus=\"toggle($event)\">\n    <option v-for=\"opt in options\" :value=\"opt.id\">[[ opt.name ]]</option>\n </select>-->\n\n <button type=\"button\" class=\"Input Dropsel--btn\" @click=\"toggle\">[[ selectedName ]]</button>\n\n <ul class=\"Dropsel\" :class=\"{'open': active }\">\n   <li v-for=\"opt in options\" @click=\"selectOption(opt)\" :class=\"{'is-active' : isActive(opt) }\">[[ opt.name ]]</li>\n </ul>\n\n</div>\n      ",
  props: ['value', 'options'],
  data: function data() {
    return {
      active: false
    };
  },
  mounted: function mounted() {
    if (!this.value) {
      this.selectOption(this.options[0]);
    }
  },
  methods: {
    toggle: function toggle() {
      this.active = !this.active;
    },
    close: function close(e) {
      if (!this.$el.contains(e.target) && this.active) {
        this.active = false;
      }
    },
    setValue: function setValue(e) {
      var value = e.target.value;
      this.value = isInt(parseInt(value)) ? parseInt(value) : value;
      this.active = false;
      console.log(e, parseInt(this.value));
      this.$emit('input', this.value);
    },
    selectOption: function selectOption(opt) {
      this.value = opt['id'];
      this.active = false;
      this.$emit('input', this.value);
    },
    isActive: function isActive(opt) {
      return opt['id'] == this.value;
    }
  },
  computed: {
    selectedName: function selectedName() {
      var _this12 = this;

      var found = this.options.find(function (opt) {
        return opt['id'] === _this12.value;
      });
      return found ? found.name : '';
    }
  },
  created: function created() {
    window.addEventListener('click', this.close);
  },
  destroyed: function destroyed() {
    window.removeEventListener('click', this.close);
  }
});
Vue.component('form-autocomplete', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin, eventMixin],
  props: ['id', 'key', 'name', 'value', 'label', 'excepts', 'config'],
  data: function data() {
    return {
      options: [],
      errors: [],
      showOptions: false,
      open: false
    };
  },
  methods: {
    hideSearch: function hideSearch(close) {
      this.showOptions = false;

      if (close) {
        this.open = false;
      }
    },
    showSearch: function showSearch() {
      if (this.open && this.filteredOptions.length) {
        this.showOptions = true;
      }
    },
    tryChange: function tryChange(e) {
      var _this13 = this;

      if (e.keyCode == 13) {
        var value = this.value[this.config.keyLabel].toLowerCase();

        if (this.filteredOptions.length && value) {
          var found = this.filteredOptions.filter(function (o) {
            return o[_this13.config.keyLabel].toLowerCase().indexOf(value) != -1;
          });

          if (found.length) {
            this.change(found[0]);
          } else {
            this.eventHub.$emit("alert:warningNotAvailable:open");
          }
        } else {
          this.eventHub.$emit("alert:warningNotAvailable:open");
        }
      }
    },
    change: function change(value, close) {
      this.errors = [];
      this.value = value;

      if (this.config.repeater) {
        this.lawyerHub.$emit("value:".concat(this.name), this.id, this.value);
      } else if (this.config.alone) {
        this.lawyerHub.$emit('change', this.name, this.value[this.config.keyId]);
        this.lawyerHub.$emit('change', this.name + '_obj', this.value);
      } else {
        this.lawyerHub.$emit('change', this.name, this.value);
      }

      this.hideSearch(close);
    },
    deselect: function deselect(val) {
      var opt = {};
      opt[this.config.keyLabel] = val;

      if (val) {
        opt[this.config.keyId] = this.randomId();
      }

      this.change(opt, false);
    },
    keypress: function keypress(event) {},
    search: function search(event) {
      var _this14 = this;

      this.open = true;
      var value = event.target.value;
      this.deselect(value);
      this.list(this.config.endpoint + value.toLowerCase(), null, function (res) {
        _this14.options = res;

        if (res.length) {
          _this14.showSearch();
        }
      });
    }
  },
  watch: {
    value: function value() {
      this.errors = [];
    }
  },
  computed: {
    filteredOptions: function filteredOptions() {
      var _this15 = this;

      if (this.excepts) {
        return this.options.reduce(function (prev, curr) {
          var exist = _this15.excepts.some(function (el) {
            return el.id === curr.id && el.id != _this15.value;
          });

          if (!exist) {
            prev.push(curr);
          }

          return prev;
        }, []);
      } else {
        return this.options;
      }
    },
    requiredLabel: function requiredLabel() {
      return this.label + (this.config.required ? ' *' : '');
    },
    searched: function searched() {
      return !this.value ? '' : this.value[this.config.keyLabel];
    },
    hasErrors: function hasErrors() {
      return Object.keys(this.errors).length;
    }
  },
  filters: {
    join: function join(data) {
      return Object.values(data).join(',');
    },
    getValue: function getValue(value, key) {
      return !value || !value.hasOwnProperty(key) ? '' : value[key];
    }
  },
  mounted: function mounted() {
    var _this16 = this;

    this.lawyerHub.$on("error:".concat(this.name, ":").concat(this.id), function (error) {
      return _this16.errors = error;
    });
  },
  template: "<div\nclass=\"form-group rel prs-lg\"\n:class=\"{'has-error': hasErrors}\"\nv-if=\"config\">\n\n  <label\n  v-if=\"label\"\n  class=\"Label\"\n  :for=\"name\">[[ requiredLabel ]]</label>\n\n  <a class=\"inline-block mtx\"\n    :href=\"config.editable\"\n    v-if=\"config.editable\"\n    target=\"_blank\">\n      Modifier les informations de mon cabinet\n  </a>\n\n  <input\n  :id=\"id\"\n  :name=\"name\"\n  class=\"Input\"\n  :value=\"searched\"\n  :required=\"config.required\"\n  :disabled=\"config.disabled\"\n  :autocomplete=\"config.autocomplete\"\n  type=\"text\"\n  @input=\"search($event)\"\n  @blur=\"hideSearch(true)\"\n  @focusout=\"hideSearch(true)\"\n  @keyup=\"tryChange($event)\">\n\n  <ul\n  class=\"Search__results blog\"\n  :class=\"{'is-open' : showOptions}\">\n    <li\n    v-for=\"opt in filteredOptions\"\n    @click=\"change(opt, true)\">\n      <div><p>[[ opt | getValue(config.keyLabel) ]]</p></div>\n    </li>\n  </ul>\n\n  <p\n  class=\"error\"\n  v-if=\"hasErrors\">\n    [[ errors | join ]]\n  </p>\n\n</div>\n"
});
Vue.component('form-checkbox', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  template: "<div class=\"flex items-center\">\n\n  <label\n  class=\"show-public\"\n  :for=\"id\">\n    [[ label ]]\n  </label>\n\n  <div class=\"switch\">\n\n    <input\n    type=\"checkbox\"\n    :name=\"name\"\n    :id=\"id\"\n    :checked=\"value\"\n    @change=\"toggle($event)\">\n\n    <label :for=\"id\"></label>\n\n  </div>\n\n</div>\n",
  props: ['id', 'key', 'label', 'name', 'value', 'config'],
  data: function data() {
    return {};
  },
  methods: {
    toggle: function toggle(event) {
      this.value = event.target.checked;

      if (this.config && this.config.repeater) {
        this.lawyerHub.$emit("value:".concat(this.name), this.id, this.value);
      } else {
        this.lawyerHub.$emit('change', this.name, this.value);
      }
    }
  }
});
Vue.component('form-input', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin, eventMixin],
  template: "<div\nv-if=\"config\"\nclass=\"form-group rel ck-editor\"\n:class=\"{'has-error': hasErrors}\">\n\n  <label\n  v-if=\"label\"\n  class=\"Label\"\n  :for=\"name\">[[ requiredLabel ]]</label>\n\n  <p\n  v-if=\"sublabel\"\n  v-html=\"sublabel\"></p>\n\n  <textarea\n  v-if=\"isTextarea\"\n  class=\"Input textarea\"\n  :name=\"name\"\n  :id=\"id\"\n  v-html=\"value\"\n  :disabled=\"config.disabled\"\n  :placeholder=\"config.placeholder\"\n  @input=\"change($event)\"\n  @focusout=\"blur()\"\n  cols=\"40\"\n  rows=\"5\"></textarea>\n\n  <input\n  v-if=\"isYear\"\n  class=\"Input\"\n  type=\"number\"\n  :min=\"min\"\n  :max=\"today\"\n  step=\"1\"\n  :name=\"name\"\n  :placeholder=\"today\"\n  :id=\"id\"\n  :value=\"value\"\n  :autocomplete=\"config.autocomplete\"\n  :disabled=\"config.disabled\"\n  @input=\"change($event)\"\n  @blur=\"blur()\"\n  @focusout=\"blur()\">\n\n  <input\n  v-if=\"!isTextarea && !isYear\"\n  class=\"Input\"\n  :type=\"type\"\n  :name=\"name\"\n  :id=\"id\"\n  :value=\"value\"\n  :disabled=\"config.disabled\"\n  :autocomplete=\"config.autocomplete\"\n  :placeholder=\"config.placeholder\"\n  @input=\"change($event)\"\n  @blur=\"blur()\"\n  @focusout=\"blur()\">\n\n  <p\n  class=\"error\"\n  v-if=\"hasErrors\">\n    [[ errors | join ]]\n  </p>\n\n  <slot name=\"link\"></slot>\n\n</div>\n",
  props: ['id', 'key', 'name', 'value', 'label', 'sublabel', 'config', 'editable'],
  data: function data() {
    return {
      min: 1800,
      today: new Date().getFullYear(),
      errors: {},
      editor: null
    };
  },
  mounted: function mounted() {
    var _this17 = this;

    /*this.editable = (this.config.hasOwnProperty('disabled')) ? this.config.disabled : true;
    this.eventHub.$on('edit',(bool) => {
      this.editable = (this.config.hasOwnProperty('disabled')) ? this.config.disabled : bool;
    });*/
    this.lawyerHub.$on("error:".concat(this.name, ":").concat(this.id), function (error) {
      return _this17.errors = error;
    });

    if (this.isTextarea) {
      this.setEditor();
    }
  },
  methods: {
    setEditor: function setEditor() {
      var _this18 = this;

      this.lawyerHub.$on('editor:init', function () {
        _this18.editor = CKEDITOR.replace(_this18.name, {
          customConfig: window.confCKeditor
        });

        _this18.editor.on('change', function (event) {
          return _this18.change();
        });

        _this18.editor.on('blur', function (event) {
          return _this18.blur();
        });
      });
    },
    blur: function blur() {//this.eventHub.$emit('edit', false);
    },
    change: function change(event) {
      this.errors = [];

      if (!this.config.disabled) {
        //this.eventHub.$emit('edit', true);
        this.value = this.isTextarea ? this.editor.getData() : event.target.value;
        this.errors = {};

        if (this.config.repeater) {
          this.lawyerHub.$emit("value:".concat(this.name), this.id, this.value);
        } else {
          this.lawyerHub.$emit("change", this.name, this.value);
        }
      }
    }
  },
  filters: {
    join: function join(data) {
      return Object.values(data).join(',');
    }
  },
  computed: {
    requiredLabel: function requiredLabel() {
      return this.label + (this.config && this.config.required ? ' *' : '');
    },
    type: function type() {
      return this.config && this.config.type ? this.config.type : 'text';
    },
    isTextarea: function isTextarea() {
      return this.type == 'textarea';
    },
    isYear: function isYear() {
      return this.type == 'year';
    },
    hasErrors: function hasErrors() {
      return Object.keys(this.errors).length;
    }
  }
});
Vue.component('form-linked-repeater', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  props: ['id', 'name', 'values', 'label', 'addlabel', 'config', 'childrenconfig'],
  data: function data() {
    return {
      init: false
    };
  },
  watch: {
    values: function values(data) {
      if (this.init) {
        this.save();
      }

      this.init = true;
    }
  },
  filters: {
    getLabel: function getLabel(row, labelKey) {
      return row[labelKey];
    },
    getValue: function getValue(row, idKey) {
      return row[idKey];
    },
    getChildLabel: function getChildLabel(row, childKey, labelKey) {
      return row.hasOwnProperty(childKey + '_obj') ? row[childKey + '_obj'][labelKey] : '';
    },
    getChildValue: function getChildValue(row, childKey, idKey) {
      return row.hasOwnProperty(childKey + '_obj') ? row[childKey + '_obj'][idKey] : '';
    }
  },
  methods: {
    add: function add() {
      if (!this.hasMax) {
        var r = {};
        r[this.config.keyLabel] = '';
        r[this.config.keyId] = this.randomId();

        if (this.config.partialRemoved) {
          r = this.setCreated(r);
        }

        this.values.push(r);
        this.save();
      }
    },
    remove: function remove(index) {
      var _this19 = this;

      if (!this.hasMin) {
        if (this.config.partialRemoved) {
          this.values = this.values.map(function (r, i) {
            if (i == index) {
              r = _this19.setRemoved(r);
            }

            return r;
          });
        } else {
          this.values = this.values.filter(function (r, i) {
            return i != index;
          });
        }
      }
    },
    change: function change(key, value) {
      var _this20 = this;

      var id = key.split('-')[1];
      this.values = this.values.map(function (r, i) {
        if (id == i) {
          var val = r;

          if (typeof value === 'string' || value instanceof String) {
            val[_this20.config.keyLabel] = value;
          } else {
            val = value;
          }

          if (_this20.config.partialRemoved) {
            val = _this20.setStatus(_this20.isChanged(r), val);
          }

          return val;
        }

        return r;
      });
    },
    save: function save(data) {
      this.lawyerHub.$emit('change', this.name, this.configValues);

      if (this.config.isList) {
        this.lawyerHub.$emit('change', this.name + '_obj', this.values);
      }
    },
    errors: function errors(error, data) {
      var _this21 = this;

      var index = this.values.findIndex(function (v) {
        return data.id == v.id;
      });
      this.lawyerHub.$emit("error:".concat(this.name, ":").concat(index), ['Merci de choisir une valeur dans la liste proposée.']);
      ;

      if (this.config.isList) {
        this.values.forEach(function (v, i) {
          var id = v[_this21.config.keyId],
              label = v[_this21.config.keyLabel];

          if (id.toString().indexOf('_') != -1) {
            _this21.lawyerHub.$emit("error:".concat(_this21.name, ":").concat(_this21.name + '-' + i), ['Merci de choisir une valeur dans la liste proposée.']);
          } else if (!id) {
            _this21.lawyerHub.$emit("error:".concat(_this21.name, ":").concat(_this21.name + '-' + i), ['Ce champ ne peut être vide.']);
          }
        });
      }
    }
  },
  computed: {
    length: function length() {
      var _this22 = this;

      return this.values ? this.values.filter(function (v) {
        return !_this22.isRemoved(v);
      }).length : 0;
    },
    hasMax: function hasMax() {
      return this.config.max && this.length >= parseInt(this.config.max) ? true : false;
    },
    hasMin: function hasMin() {
      return this.config.min && this.length <= parseInt(this.config.min) ? true : false;
    },
    configValues: function configValues() {
      var _this23 = this;

      return !this.config.isList ? this.values : this.values.map(function (r) {
        return r[_this23.config.keyId];
      });
    },
    setLabels: function setLabels() {
      return [this.label, this.childrenconfig.label];
    },
    labels: function labels() {
      return this.label + ' & ' + this.childrenconfig.label;
    }
  },
  mounted: function mounted() {
    var _this24 = this;

    this.lawyerHub.$on("value:".concat(this.name), function (id, value) {
      return _this24.change(id, value);
    });
    this.lawyerHub.$on("errors:".concat(this.name), function (error, data) {
      return _this24.errors(error, data);
    });
  },
  template: "<div>\n  <div class=\"row hide flex-lg\">\n    <div class=\"col-lg-6\" v-for=\"label in setLabels\">\n      <label class=\"Label\">[[ label ]]</label>\n    </div>\n  </div>\n\n  <div class=\"row flex hide-lg mts\">\n    <div class=\"col\">\n    <label class=\"Label\">[[ labels ]]</label>\n    </div>\n  </div>\n\n   <div class=\"row mbs\"\n  v-for=\"(r, i) in values\"\n   v-if=\"r && !isRemoved(r)\">\n\n    <div class=\"col-lg-6 rel\">\n\n        <form-autocomplete\n        :id=\"name + '-' + i\"\n        :name=\"name\"\n        :value=\"r\"\n        :config=\"config\"\n        :excepts=\"values\">\n        </form-autocomplete>\n\n    </div>\n\n    <div class=\"col-lg-6 mts mtn-lg\">\n     <div class=\"form-group rel prl\">\n\n        <form-input\n        :id=\"config.keyChild + '-' + i\"\n        :name=\"config.keyChild + '-' +name\"\n        :value=\"r | getChildLabel(config.keyChild, config.keyLabel)\"\n        :config=\"childrenconfig\">\n        </form-input>\n\n      <a @click=\"remove(i)\" :class=\"{'hide' : hasMin}\">\n       <img\n       class=\"delete-firm\"\n       src=\"/static/svg/private/close-icon.svg\"\n       title=\"Delete\" alt=\"close icon\">\n     </a>\n    </div>\n    </div>\n  </div>\n\n  <button class=\"Btn--add\" @click=\"add()\" :class=\"{'hide' : hasMax}\">[[ addlabel ]]</button>\n</div>\n"
});
Vue.component('form-multiple-repeater', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  props: ['id', 'name', 'values', 'addlabel', 'config', 'rows'],
  data: function data() {
    return {
      init: false
    };
  },
  watch: {
    values: function values(data) {
      if (this.init) {
        this.save();
      }

      this.init = true;
    }
  },
  filters: {
    getLabel: function getLabel(row, config) {
      return config ? row[config.keyLabel] : '';
    },
    getValue: function getValue(row, config) {
      return config ? row[config.keyId] : '';
    }
  },
  methods: {
    add: function add() {
      if (!this.hasMax) {
        var r = {};
        this.rows.forEach(function (v) {
          r[v.keyLabel] = '';
        });
        r[this.config.keyId] = this.randomId();

        if (this.config.partialRemoved) {
          r = this.setCreated(r);
        }

        this.values.push(r);
        this.save();
      }
    },
    remove: function remove(index) {
      var _this25 = this;

      if (!this.hasMin) {
        if (this.config.partialRemoved) {
          this.values = this.values.map(function (r, i) {
            if (i == index) {
              r = _this25.setRemoved(r);
            }

            return r;
          });
        } else {
          this.values = this.values.filter(function (r, i) {
            return i != index;
          });
        }
      }
    },
    errors: function errors(error, data) {
      var _this26 = this;

      if (data) {
        var index = this.values.findIndex(function (v) {
          return data.id == v.id;
        });
        Object.keys(error).forEach(function (o) {
          _this26.lawyerHub.$emit("error:".concat(o, ":").concat(_this26.name + '-' + index), error);
        });
      }
    },
    change: function change(key, name, value) {
      var _this27 = this;

      var id = key.split('-')[1];
      this.values = this.values.map(function (r, i) {
        if (id == i) {
          if (_this27.config.partialRemoved) {
            r = _this27.setStatus(_this27.isChanged(r), r);
          }

          r[name] = value;
        }

        return r;
      });
    },
    save: function save(data) {
      this.lawyerHub.$emit('change', this.name, this.configValues);

      if (this.config.isList) {
        this.lawyerHub.$emit('change', this.name + '_obj', this.values);
      }
    },
    deleteRow: function deleteRow(id, data) {
      var _this28 = this;

      this.values = this.values.filter(function (r) {
        return r[_this28.config.keyId] == id ? _this28.setAlreadyRemoved(r) : r;
      });
    },
    postRow: function postRow(id, data) {
      var _this29 = this;

      this.values = this.values.map(function (r, i) {
        return r[_this29.config.keyId] == id ? data : r;
      });
    }
  },
  computed: {
    length: function length() {
      var _this30 = this;

      return this.values ? this.values.filter(function (v) {
        return !_this30.isRemoved(v);
      }).length : 0;
    },
    hasMax: function hasMax() {
      return this.config.max && this.length >= parseInt(this.config.max) ? true : false;
    },
    hasMin: function hasMin() {
      return this.config.min && this.length <= parseInt(this.config.min) ? true : false;
    },
    configValues: function configValues() {
      var _this31 = this;

      return !this.config.isList ? this.values : this.values.map(function (r) {
        return r[_this31.config.keyId];
      });
    },
    labels: function labels() {
      return this.rows.map(function (r) {
        return r.label;
      }).join(' & ');
    }
  },
  mounted: function mounted() {
    var _this32 = this;

    this.lawyerHub.$on("errors:".concat(this.name), function (error, data) {
      return _this32.errors(error, data);
    });
    this.rows.forEach(function (r) {
      _this32.lawyerHub.$on("value:".concat(r.id), function (id, data) {
        return _this32.change(id, r.id, data);
      });
    });
    this.lawyerHub.$on("deleteRow:".concat(this.name), function (id, data) {
      return _this32.deleteRow(id, data);
    });
    this.lawyerHub.$on("postRow:".concat(this.name), function (id, data) {
      return _this32.postRow(id, data);
    });
  },
  template: "<div>\n  <div class=\"form-group rel full-w\">\n\n   <div class=\"row hide flex-sm\" v-if=\"rows && rows.length\">\n     <div class=\"col-sm-6\" v-for=\"conf in rows\">\n      <div class=\"form-group js-form-group prs-lg\">\n        <label class=\"Label\" for=\"\">[[ conf.label ]]</label>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row flex hide-sm\" v-if=\"rows && rows.length\">\n   <div class=\"col\">\n    <div class=\"form-group js-form-group prs-lg\">\n      <label class=\"Label\" for=\"\">[[labels]]</label>\n    </div>\n  </div>\n  </div>\n\n\n    <div class=\"form-group mbs-sm rel\"\n    v-for=\"(r, i) in values\"\n    v-if=\"r && !isRemoved(r) && !isAlreadyRemoved(r)\">\n\n      <div class=\"row row-degree prl prn-sm\" v-if=\"rows && rows.length\">\n         <div\n         class=\"mbs mbn-sm\"\n         :class=\"[(ri == 0) ? 'col-sm-6' : 'col-sm-3']\"\n         v-for=\"(conf, ri) in rows\">\n            <form-select\n            v-if=\"!conf.endpoint && conf.options\"\n            :name=\"conf.id\"\n            :id=\"name + '-' + i\"\n            :key=\"r.id\"\n            :value=\"r | getValue(conf)\"\n            :excepts=\"values\"\n            :config=\"conf\">\n            </form-select>\n\n            <form-input\n            v-if=\"conf.type != 'autocomplete' && conf.type != 'select'\"\n            :name=\"conf.id\"\n            :id=\"name + '-' + i\"\n            :key=\"r.id\"\n            :value=\"r | getLabel(conf)\"\n            :config=\"conf\">\n            </form-input>\n\n            <form-autocomplete\n            v-if=\"conf.type == 'autocomplete'\"\n            :id=\"name + '-' + i\"\n            :name=\"conf.id\"\n            :value=\"r\"\n            :key=\"r.id\"\n            :excepts=\"values\"\n            :config=\"conf\">\n            </form-autocomplete>\n        </div>\n\n          <div class=\"col-sm-2 rel hide-xs show-sm\">\n            <a @click=\"remove(i)\" :class=\"{'hide' : hasMin }\">\n             <img\n             class=\"delete-degree\"\n             src=\"/static/svg/private/close-icon.svg\"\n             title=\"Delete\" alt=\"close icon\"/>\n           </a>\n        </div>\n\n            <a class=\"hide-sm mrs\"\n            @click=\"remove(i)\" :class=\"{'hide' : hasMin }\">\n             <img\n             class=\"delete-firm\"\n             src=\"/static/svg/private/close-icon.svg\"\n             title=\"Delete\" alt=\"close icon\"/>\n           </a>\n      </div>\n   </div>\n\n  </div>\n\n  <button class=\"Btn--add\" @click=\"add()\" :class=\"{'hide' : hasMax}\">[[ addlabel ]]</button>\n</div>\n"
});
Vue.component('form-options', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  template: "<div class=\"form-group rel full-w\" v-if=\"options.length\">\n\n  <label class=\"Label\" :for=\"name\" v-if=\"label\">[[ label ]]</label>\n\n  <div class=\"row\">\n    <div class=\"col-lg-6 mts\" v-for=\"opt in options\">\n      <div :class=\"['Input__' + type]\">\n       <label>\n\n          <input\n          :type=\"type\"\n          :id=\"opt[config.keyId]\"\n          :name=\"name\"\n          :value=\"opt[config.keyId]\"\n          :checked=\"values | getChecked(opt[config.keyId])\"\n          @change=\"change($event)\">\n\n          <span></span>\n          [[ opt[config.keyLabel] ]]\n        </label>\n      </div>\n    </div>\n  </div>\n\n</div>\n",
  props: ['id', 'name', 'values', 'label', 'config'],
  data: function data() {
    return {};
  },
  methods: {
    toggle: function toggle(value) {
      var index = this.values.indexOf(value);

      if (index != -1) {
        this.values.splice(index, 1);
      } else {
        this.values.push(value);
      }
    },
    change: function change(event) {
      var value = parseInt(event.target.value);

      if (this.isCheckbox) {
        this.toggle(value);
      } else {
        this.values = value;
      }

      if (this.config && this.config.repeater) {
        this.lawyerHub.$emit("value:".concat(this.name), this.id, this.values);
      } else {
        this.lawyerHub.$emit('change', this.name, this.values);
      }
    }
  },
  filters: {
    getChecked: function getChecked(values, value) {
      return values && values.indexOf(value) != -1;
    }
  },
  computed: {
    options: function options() {
      return this.config.options ? this.config.options : [];
    },
    type: function type() {
      return this.config.type ? this.config.type : 'checkbox';
    },
    isCheckbox: function isCheckbox() {
      return !this.type || this.type == 'checkbox';
    }
  }
});
Vue.component('form-repeater', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin, eventMixin],
  props: ['id', 'name', 'values', 'label', 'sublabel', 'addlabel', 'config'],
  data: function data() {
    return {
      init: false
    };
  },
  watch: {
    values: function values(data) {
      if (this.init) {
        this.save();
      }

      this.init = true;
    }
  },
  methods: {
    add: function add() {
      if (!this.hasMax) {
        var r = {};
        r[this.config.keyLabel] = '';
        r[this.config.keyId] = this.randomId();

        if (this.config.partialRemoved) {
          r = this.setCreated(r);
        }

        this.values.push(r);
        this.save();
      }
    },
    remove: function remove(index) {
      var _this33 = this;

      if (!this.hasMin) {
        if (this.config.partialRemoved) {
          this.values = this.values.map(function (r, i) {
            if (i == index) {
              r = _this33.setRemoved(r);
            }

            return r;
          });
        } else {
          this.values = this.values.filter(function (r, i) {
            return i != index;
          });
        }
      }
    },
    change: function change(key, value) {
      var _this34 = this;

      var id = key.split('-')[1];
      this.values = this.values.map(function (r, i) {
        if (id == i) {
          var val = r;

          if (typeof value === 'string' || value instanceof String) {
            val[_this34.config.keyLabel] = value;
          } else {
            val = value;
          }

          if (_this34.config.partialRemoved) {
            val = _this34.setStatus(_this34.isChanged(r) || !_this34.getStatus(r), val);
          }

          return val;
        }

        return r;
      });
    },
    save: function save(data) {
      this.lawyerHub.$emit('change', this.name, this.configValues);

      if (this.config.isList) {
        this.lawyerHub.$emit('change', this.name + '_obj', this.values);
      }
    },
    errors: function errors(error, data) {
      var _this35 = this;

      var index = this.values.findIndex(function (v) {
        return data[_this35.config.keyId] == v[_this35.config.keyId];
      });
      this.lawyerHub.$emit("error:".concat(this.name, ":").concat(this.name + '-' + index), error);
      ;

      if (this.config.isList) {
        this.values.forEach(function (v, i) {
          var id = v[_this35.config.keyId],
              label = v[_this35.config.keyLabel];

          if (id.toString().indexOf('_') != -1) {
            _this35.lawyerHub.$emit("error:".concat(_this35.name, ":").concat(_this35.name + '-' + i), ['Merci de choisir une valeur dans la liste proposée.']);
          }
        });
      }
    },
    deleteRow: function deleteRow(id, data) {
      var _this36 = this;

      this.values = this.values.filter(function (r) {
        return r[_this36.config.keyId] == id ? _this36.setAlreadyRemoved(r) : r;
      });
    },
    postRow: function postRow(id, data) {
      var _this37 = this;

      this.values = this.values.map(function (r, i) {
        return r[_this37.config.keyId] == id ? data : r;
      });
    }
  },
  computed: {
    length: function length() {
      var _this38 = this;

      return this.values ? this.values.filter(function (v) {
        return !_this38.isRemoved(v) && !_this38.isAlreadyRemoved(v);
      }).length : 0;
    },
    hasMax: function hasMax() {
      return this.config.max && this.length >= parseInt(this.config.max) ? true : false;
    },
    hasMin: function hasMin() {
      return this.config.min && this.length <= parseInt(this.config.min) ? true : false;
    },
    configValues: function configValues() {
      var _this39 = this;

      return !this.config.isList ? this.values : this.values.map(function (r) {
        return r[_this39.config.keyId];
      });
    },
    isSelect: function isSelect() {
      return this.config && this.config.type == "select";
    },
    isAutocomplete: function isAutocomplete() {
      return this.config && this.config.type == "autocomplete";
    }
  },
  filters: {
    getValue: function getValue(val, label) {
      return val ? val[label] : '';
    }
  },
  mounted: function mounted() {
    var _this40 = this;

    this.lawyerHub.$on("value:".concat(this.name), function (id, value) {
      return _this40.change(id, value);
    });
    this.lawyerHub.$on("errors:".concat(this.name), function (error, data) {
      return _this40.errors(error, data);
    });
    this.lawyerHub.$on("deleteRow:".concat(this.name), function (id, data) {
      return _this40.deleteRow(id, data);
    });
    this.lawyerHub.$on("postRow:".concat(this.name), function (id, data) {
      return _this40.postRow(id, data);
    });
  },
  template: "<div v-if=\"config\">\n  <div class=\"form-group rel full-w\">\n\n    <label\n    class=\"Label\"\n    :for=\"name\">\n      [[ label ]]\n    </label>\n\n    <p\n    v-if=\"sublabel\"\n    v-html=\"sublabel\"></p>\n\n    <div class=\"form-group mbs rel prl\"\n    v-for=\"(r, i) in values\"\n    v-if=\"r && !isRemoved(r) && !isAlreadyRemoved(r)\">\n\n        <form-select\n        v-if=\"isSelect\"\n        :name=\"name\"\n        :id=\"name + '-' + i\"\n        :value=\"r | getValue(config.keyId)\"\n        :excepts=\"values\"\n        :config=\"config\">\n        </form-select>\n\n        <form-autocomplete\n        v-if=\"isAutocomplete\"\n        :name=\"name\"\n        :id=\"name + '-' + i\"\n        :value=\"r\"\n        :excepts=\"values\"\n        :config=\"config\">\n        </form-autocomplete>\n\n        <form-input\n        v-if=\"!isSelect && !isAutocomplete\"\n        :name=\"name\"\n        :id=\"name + '-' + i\"\n        :value=\"r[config.keyLabel]\"\n        :config=\"config\">\n        </form-input>\n\n      <a @click=\"remove(i)\" :class=\"{'hide' : hasMin }\">\n        <img\n        class=\"delete-firm\"\n        src=\"/static/svg/private/close-icon.svg\"\n        title=\"Delete\" alt=\"close icon\"/>\n      </a>\n   </div>\n  </div>\n\n  <button\n  class=\"Btn--add\"\n  @click=\"add()\"\n  :class=\"{'hide' : hasMax}\">\n    [[ addlabel ]]\n  </button>\n\n</div>\n"
});
Vue.component('form-rows', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  template: "<div>\n  <div class=\"form-group rel full-w\">\n\n    <div class=\"form-group mbs rel\"\n    v-for=\"(r, i) in rows\">\n\n        <form-input\n        v-if=\"!isAutocomplete\"\n        :id=\"name + '-' + i\"\n        :name=\"name\"\n        :value=\"r[config.keyLabel]\"\n        :label=\"r | generateLabel(config.type)\"\n        v-bind:config=\"config\">\n        </form-input>\n\n        <form-autocomplete\n        v-if=\"isAutocomplete\"\n        :id=\"name + '-' + i\"\n        :name=\"name\"\n        :value=\"r\"\n        :label=\"label + ' ' + (i + 1)\"\n        :excepts=\"values\"\n        v-bind:config=\"config\">\n        </form-autocomplete>\n\n      </div>\n\n   </div>\n\n  </div>\n</div>\n",
  props: ['id', 'name', 'values', 'label', 'sublabel', 'config'],
  data: function data() {
    return {
      init: false
    };
  },
  filters: {
    generateLabel: function generateLabel(row, type) {
      return type == 'url' ? row.label : '';
    }
  },
  watch: {
    values: function values(data) {
      if (this.init) {
        this.save();
      }

      this.init = true;
    }
  },
  methods: {
    change: function change(key, value) {
      var _this41 = this;

      var id = key.split('-')[1];
      this.values = this.rows.map(function (r, i) {
        if (id == i) {
          var val = r;

          if (typeof value === 'string' || value instanceof String) {
            val[_this41.config.keyLabel] = value;

            if (_this41.config.partialRemoved) {
              if (!value) {
                val = _this41.setRemoved(val);
              } else {
                var isChanged = r.hasOwnProperty('id');
                val = _this41.setStatus(isChanged, val);
              }
            }
          } else {
            val = value;
          }

          return val;
        }

        return r;
      });
    },
    errors: function errors(error, data) {
      var _this42 = this;

      var index = this.values.findIndex(function (v) {
        return data[_this42.config.keyId] == v[_this42.config.keyId];
      });
      this.lawyerHub.$emit("error:".concat(this.name, ":").concat(this.name + '-' + index), error);
      ;

      if (this.config.isList) {
        this.values.forEach(function (v, i) {
          var id = v[_this42.config.keyId],
              label = v[_this42.config.keyLabel];

          if (id && id.toString().indexOf('_') != -1 && label) {
            _this42.lawyerHub.$emit("error:".concat(_this42.name, ":").concat(_this42.name + '-' + i), ['Merci de choisir une valeur dans la liste proposée.']);
          }
        });
      }
    },
    save: function save() {
      this.lawyerHub.$emit('change', this.name, this.configValues);

      if (this.config.isList) {
        this.lawyerHub.$emit('change', this.name + '_obj', this.values);
      }
    },
    patchRow: function patchRow(id, data) {
      var _this43 = this;

      this.values = this.values.map(function (r, i) {
        return r[_this43.config.keyId] == id ? data : r;
      });
    },
    deleteRow: function deleteRow(id, data) {
      var _this44 = this;

      this.values = this.values.map(function (r, i) {
        return r[_this44.config.keyId] == id ? data : r;
      });
    },
    postRow: function postRow(id, data) {
      var _this45 = this;

      this.values = this.values.map(function (r, i) {
        return r[_this45.config.keyId] == id ? data : r;
      });
    }
  },
  computed: {
    isAutocomplete: function isAutocomplete() {
      return this.config && this.config.type == 'autocomplete';
    },
    configValues: function configValues() {
      var _this46 = this;

      if (this.config.isList) {
        return this.values.reduce(function (prev, curr) {
          if (_this46.config.partialRemoved) {
            prev.push(curr[_this46.config.keyId]);
          } else if (curr[_this46.config.keyId] && curr[_this46.config.keyLabel]) {
            prev.push(curr[_this46.config.keyId]);
          }

          return prev;
        }, []);
      }

      return this.values;
    },
    rows: function rows() {
      var data = [];

      for (var i = 0; i < this.config.number; i++) {
        if (this.values && this.values[i]) {
          data.push(this.values[i]);
        } else {
          data.push({
            id: this.randomId()
          });
        }
      }

      return data;
    }
  },
  mounted: function mounted() {
    var _this47 = this;

    this.lawyerHub.$on("value:".concat(this.name), function (id, value) {
      return _this47.change(id, value);
    });
    this.lawyerHub.$on("errors:".concat(this.name), function (error, data) {
      return _this47.errors(error, data);
    });
    this.lawyerHub.$on("postRow:".concat(this.name), function (id, data) {
      return _this47.postRow(id, data);
    });
    this.lawyerHub.$on("patchRow:".concat(this.name), function (id, data) {
      return _this47.patchRow(id, data);
    });
    this.lawyerHub.$on("deleteRow:".concat(this.name), function (id, data) {
      return _this47.deleteRow(id, data);
    });
  }
});
Vue.component('form-search', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin, eventMixin],
  props: ['name', 'value', 'label', 'sublabel', 'values', 'subvalues', 'config'],
  data: function data() {
    return {
      searchVal: '',
      init: false
    };
  },
  watch: {
    values: function values(data) {
      if (this.init) {
        this.save();
      }

      this.init = true;
    }
  },
  methods: {
    change: function change(key, value) {
      var _this48 = this;

      var id = key.split('-')[1]; //remove all possibilities from values;

      var subvalues = this.subvalues.filter(function (c) {
        return !_this48.values[id]['possibilities'].includes(c);
      }); //add selected ones

      this.subvalues = _toConsumableArray(new Set(subvalues.concat(value)));
      this.save();
    },
    toggle: function toggle(index) {
      this.values = this.values.map(function (r, i) {
        if (i == index) {
          r['visible'] = r.hasOwnProperty('visible') ? !r.visible : true;
        }

        return r;
      });
    },
    toggleChildren: function toggleChildren(event, childrens) {
      if (event.target.checked) {
        this.subvalues = _toConsumableArray(new Set(this.subvalues.concat(childrens)));
      } else {
        this.subvalues = this.subvalues.filter(function (c) {
          return !childrens.includes(c);
        });
      }

      this.save();
    },
    add: function add(id, value) {
      if (value.hasOwnProperty(this.config.keyChild)) {
        this.searchVal = "";

        if (!this.hasMax) {
          this.values.push(value);
          this.subvalues = _toConsumableArray(new Set(this.subvalues.concat(value[this.config.keyChild])));
          this.save();
        } else {
          this.eventHub.$emit("alert:warningMax:open");
        }
      }
    },
    remove: function remove(index) {
      if (!this.hasMin) {
        this.values = this.values.filter(function (r, i) {
          return i != index;
        });
      }
    },
    errors: function errors(error, data) {
      var _this49 = this;

      Object.keys(error).forEach(function (err) {
        _this49.lawyerHub.$emit("error:".concat(_this49.name, ":").concat(_this49.name + '-' + data[_this49.config.keyId]), error[err]);
      });
    },
    save: function save() {
      this.lawyerHub.$emit('change', this.config.keyChild, this.subvalues);
      this.lawyerHub.$emit('change', this.name, this.configValues);

      if (this.config.isList) {
        this.lawyerHub.$emit('change', this.name + '_obj', this.values);
      }
    }
  },
  computed: {
    length: function length() {
      var _this50 = this;

      return this.values ? this.values.filter(function (v) {
        return !_this50.isRemoved(v);
      }).length : 0;
    },
    hasMax: function hasMax() {
      return this.config.max && this.length >= parseInt(this.config.max) ? true : false;
    },
    hasMin: function hasMin() {
      return this.config.min && this.length <= parseInt(this.config.min) ? true : false;
    },
    configValues: function configValues() {
      var _this51 = this;

      return !this.config.isList ? this.values : this.values.map(function (r) {
        return r[_this51.config.keyId];
      });
    },
    parentValues: function parentValues() {
      var _this52 = this;

      if (!this.values) {
        return [];
      }

      return this.values.map(function (r) {
        var childrens = r[_this52.config.keyChild],
            options = r[_this52.config.keyChild + '_obj'];
        r['options'] = options;
        r['possibilities'] = childrens;
        r['children'] = childrens.filter(function (v) {
          return _this52.subvalues.indexOf(v) != -1;
        });
        r['isFull'] = r.children.length;
        return r;
      });
    }
  },
  mounted: function mounted() {
    var _this53 = this;

    this.lawyerHub.$on("value:".concat(this.name), function (id, value) {
      return _this53.add(id, value);
    });
    this.lawyerHub.$on("value:".concat(this.config.keyChild), function (id, value) {
      return _this53.change(id, value);
    });
    this.lawyerHub.$on("errors:".concat(this.name), function (error, data) {
      return _this53.errors(error, data);
    });
  },
  template: "<div>\n\n  <div class=\"rel\">\n    <form-autocomplete\n    :id=\"name\"\n    :name=\"name\"\n    :label=\"label\"\n    :value=\"searchVal\"\n    :excepts=\"values\"\n    :config=\"config\">\n    </form-autocomplete>\n  </div>\n\n  <div\n  class=\"skills mtm\"\n  :class=\"{'hidden-content' : !v.visible}\"\n  v-for=\"(v, i) in parentValues\"\n  v-if=\"v && !v.removed\">\n    <div class=\"close\" @click=\"remove(i)\" v-if=\"!hasMin\">\n      <img src=\"/static/svg/private/close-icon.svg\" title=\"Delete\" alt='Delete icon'>\n    </div>\n    <div class=\"Input__checkbox checkbox-head\" :class=\"{'has-error' : v.errors}\">\n      <label>\n       <input\n       type=\"checkbox\"\n       :checked=\"v.isFull\"\n       @change=\"toggleChildren($event, v.possibilities)\">\n       <span></span>\n       [[ v[config.keyLabel] ]]\n     </label>\n     <a @click=\"toggle(i)\">\n       <img\n       class=\"skill-arrow\"\n       :class=\"{'is-up' : v.visible}\"\n       src=\"/static/svg/private/arrow-down-gray.svg\"\n       alt='arrow'/>\n     </a>\n    </div>\n    <div class=\"content\" v-if=\"v.options && v.options.length\">\n       <form-options\n       :id=\"name + '-' + i\"\n       :name=\"config.keyChild\"\n       :values=\"v.children\"\n       :config=\"{\n          type: 'checkbox',\n          repeater: true,\n          keyId: config.keyId,\n          keyLabel: config.keyLabel,\n          options: v.options\n        }\">\n       </form-options>\n    </div>\n    <p class=\"error\" v-if=\"v.errors\">[[ v.errors ]]</p>\n  </div>\n\n</div>\n"
});
Vue.component('form-select', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  template: "<div\nv-if=\"config\"\nclass=\"form-group js-form-group prs-lg\"\n:class=\"{'has-error': hasErrors}\">\n\n  <label\n  class=\"Label\"\n  v-if=\"label\"\n  :for=\"name\">\n    [[label]]\n  </label>\n\n  <dropdown\n  :options=\"filteredOptions\"\n  v-model=\"value\"\n  @input=\"change\"></dropdown>\n\n  <p\n  class=\"error\"\n  v-if=\"hasErrors\">\n    [[ errors | join ]]\n  </p>\n</div>\n",
  props: ['id', 'name', 'value', 'label', 'config', 'excepts', 'key'],
  data: function data() {
    return {
      errors: []
    };
  },
  mounted: function mounted() {
    var _this54 = this;

    if (this.value[0] == "_") {
      this.change({
        target: {
          value: this.filteredOptions[0].id
        }
      });
    }

    initDropsels();
    this.lawyerHub.$on("error:".concat(this.name, ":").concat(this.id), function (error) {
      return _this54.errors = error;
    });
  },
  methods: {
    change: function change() {
      this.errors = [];

      if (this.config.repeater) {
        this.lawyerHub.$emit("value:".concat(this.name), this.id, this.val);
      } else {
        this.lawyerHub.$emit('change', this.name, this.value);
      }
    }
  },
  filters: {
    isSelected: function isSelected(optId, id) {
      return optId == id;
    },
    join: function join(data) {
      return Object.values(data).join(',');
    }
  },
  computed: {
    options: function options() {
      return this.config ? this.config.options : [];
    },
    filteredOptions: function filteredOptions() {
      var _this55 = this;

      if (this.excepts) {
        return this.options.reduce(function (prev, curr) {
          var exist = _this55.excepts.some(function (el) {
            return el.id === curr.id && el.id != _this55.value;
          });

          if (!exist) {
            prev.push(curr);
          }

          return prev;
        }, []);
      } else {
        return this.options;
      }
    },
    val: function val() {
      var _this56 = this;

      var found = this.options.find(function (o) {
        return o.id == _this56.value;
      });
      return found ? found : this.filteredOptions[0];
    },
    optLabel: function optLabel() {
      return this.val ? this.val[this.config.keyLabel] : '';
    },
    hasErrors: function hasErrors() {
      return Object.keys(this.errors).length;
    }
  }
});
Vue.component('form-video', {
  delimiters: ['[[', ']]'],
  mixins: [lawyerMixin],
  template: "<div>\n  <div class=\"flex items-end justify-between\">\n    <div class=\"form-group youtube-wrapper\">\n\n      <label\n      v-if=\"label\"\n      class=\"Label\"\n      :for=\"name\">\n        [[ label ]]\n      </label>\n\n      <input\n      class=\"Input\"\n      type=\"text\"\n      :name=\"name\"\n      :id=\"id\"\n      :placeholder=\"placeholder\"\n      :value=\"value\"\n      @input=\"change($event)\">\n\n    </div>\n\n    <div\n    class=\"Bg--cover youtube-thumbnail\"\n    :style=\"thumbnailStyle\">\n    </div>\n\n  </div>\n  <a\n  v-if=\"value\"\n  class=\"inline-block mtx\"\n  title=\"Tester le lien\"\n  :href=\"value\"\n  target=\"_blank\">Tester le lien</a>\n</div>\n",
  props: ['id', 'label', 'name', 'value', 'placeholder'],
  data: function data() {
    return {};
  },
  methods: {
    change: function change(event) {
      this.value = event.target.value;
      this.lawyerHub.$emit('change', this.name, this.value);
    }
  },
  computed: {
    thumbnail: function thumbnail() {
      if (!this.value) {
        return '/static/img/no-avatar.png';
      } else {
        var value = this.value.replace('https://www.youtube.com/watch?v=', '');
        return "http://img.youtube.com/vi/".concat(value, "/maxresdefault.jpg");
      }
    },
    thumbnailStyle: function thumbnailStyle() {
      return "background-image: url(\"".concat(this.thumbnail, "\");");
    }
  }
});
Vue.component('modal', {
  delimiters: ['[[', ']]'],
  mixins: [eventMixin],
  props: ['name', 'closable', 'classes'],
  data: function data() {
    return {
      opened: false
    };
  },
  methods: {
    hide: function hide() {
      this.unfixBody();
      this.opened = false;
    }
  },
  mounted: function mounted() {
    var _this57 = this;

    this.eventHub.$on("modal:".concat(this.name, ":close"), function () {
      _this57.unfixBody();

      _this57.opened = false;
    });
    this.eventHub.$on("modal:".concat(this.name, ":open"), function (data) {
      _this57.fixBody();

      _this57.opened = true;
    });
  },
  template: "<transition name=\"fade\">\n    <div\n    class=\"modal\"\n    v-show=\"opened\"\n    :class=\"[classes,(opened)?'is-open':'']\"\n    @click=\"hide\"\n    >\n    <div class=\"modal-wrapper\" @click.stop>\n        <button v-if=\"closable\" type=\"button\" class=\"btn close\" @click=\"hide\" tabindex=\"1\">\n          <i class=\"icon icon-close\"></i>\n        </button>\n            <div class=\"content\">\n                <slot name=\"body\">\n                </slot>\n            </div>\n        </div>\n    </div>\n</transition>\n"
});

if (document.getElementById("app_lawyer")) {
  new Vue({
    delimiters: ['[[', ']]'],
    mixins: [lawyerMixin, eventMixin],
    el: '#app_lawyer',
    data: {
      requiredKeys: ['id', 'first_name', 'last_name', 'main_law_firm'],
      lawyerId: window.lawyer,
      lawyer: {},
      lawyer_edit: {},
      postulations: [],
      degrees: [],
      social_networks: [],
      isFormLoading: true,
      isGoingToSection: false,
      mustShowWarning: false
    },
    methods: {
      changes: function changes(name, value) {
        if (this.lawyer.hasOwnProperty(name)) {
          this.lawyer[name] = value;
          /*
          REMOVE SECONDARY LAW FIRMS IF EMPTY MAIN ??
          if(name == 'main_law_firm' && !value){
              this.lawyer['secondary_law_firm'] = [];
              this.lawyer['secondary_law_firm_obj'] = [];
          }*/
        } else if (this.hasOwnProperty(name)) {
          this[name] = value;
        }
      },
      getLawyer: function getLawyer() {
        var _this58 = this;

        this.retrieve('lawyers', this.lawyerId, function (res) {
          _this58.lawyer = res;

          _this58.eventHub.$emit('edit', false); //To init CKEDITOR


          _this58.lawyerHub.$emit('editor:init');
        });
      },
      getPostulations: function getPostulations() {
        var _this59 = this;

        this.list('postulations', this.lawyerId, function (res) {
          _this59.postulations = res;
        });
      },
      getDegrees: function getDegrees() {
        var _this60 = this;

        this.list('degrees', this.lawyerId, function (res) {
          _this60.degrees = res;
        });
      },
      getSocialNetworks: function getSocialNetworks() {
        var _this61 = this;

        this.list('social_networks', this.lawyerId, function (res) {
          _this61.social_networks = _this61.setSocialsNetworks(res);
        });
      },
      setSocialsNetworks: function setSocialsNetworks(res) {
        return this.networksOptions.map(function (n) {
          var el = res.find(function (el) {
            return el.network === n.network;
          });

          if (!el) {
            return n;
          }

          el['label'] = n.label;
          return el;
        });
      },
      init: function init() {
        this.getLawyer();
        this.getPostulations();
        this.getSocialNetworks();
        this.getDegrees();
      },
      changeThumbnail: function changeThumbnail(event) {
        this.saveThumbnail(event, this.lawyer);
      },
      goToSection: function goToSection(anchor, error) {
        var _this62 = this;

        if (this.$refs[anchor] && !this.isGoingToSection) {
          this.isGoingToSection = true;
          $('html, body').animate({
            scrollTop: $(this.$refs[anchor]).offset().top
          }, 1000, function () {
            _this62.isGoingToSection = false;
          });
        }
      },
      toggleWarning: function toggleWarning(event) {
        localStorage.setItem('my-account-warning', event.target.checked);
      },
      hideWarning: function hideWarning() {
        this.mustShowWarning = false;
      },
      setErrors: function setErrors(errors) {
        var _this63 = this;

        console.log(errors);
        this.eventHub.$emit("alert:warning:open");
        Object.keys(errors).forEach(function (e, i) {
          var key = errors[e];

          if (e == 'lawyer') {
            Object.keys(key).forEach(function (o, j) {
              //this.lawyerHub.$emit(`error:${o}:${o}`, key[o]);
              _this63.eventHub.$emit("go:to", o);

              console.log(o);
            });
          } else if (key.length) {
            _this63.eventHub.$emit("go:to", e);
            /*key.forEach(o => {
                console.log(o);
            });*/

          }
        });
      },
      accountFormSave: function accountFormSave() {
        var _this64 = this;

        var saveLength = Object.keys(this.toSave).length;

        if (saveLength > 0) {
          this.eventHub.$emit('edit', true);
          var dataErrors = {};
          this.put('lawyers', this.toSave['lawyer'], function (res) {
            dataErrors['lawyer'] = [];
            _this64.lawyer = res;
          }, function (err) {
            return dataErrors['lawyer'] = err.responseJSON;
          });

          if (this.toSave.hasOwnProperty('postulations')) {
            this.saveList('postulations', this.toSave['postulations'], this.lawyerId, function (errors) {
              dataErrors['postulations'] = errors.reduce(function (prev, curr) {
                return prev.concat(curr);
              }, []);

              if (!dataErrors['postulations'].length) {
                _this64.getPostulations();
              }
            });
          }

          if (this.toSave.hasOwnProperty('social_networks')) {
            this.saveList('social_networks', this.toSave['social_networks'], this.lawyerId, function (errors) {
              dataErrors['social_networks'] = errors.reduce(function (prev, curr) {
                return prev.concat(curr);
              }, []);
            });
          }

          if (this.toSave.hasOwnProperty('degrees')) {
            this.saveList('degrees', this.toSave['degrees'], this.lawyerId, function (errors) {
              dataErrors['degrees'] = errors.reduce(function (prev, curr) {
                return prev.concat(curr);
              }, []);

              if (!dataErrors['degrees'].length) {
                _this64.getDegrees();
              }
            });
          }

          var verifySuccess = setInterval(function () {
            if (Object.keys(dataErrors).length == saveLength) {
              clearInterval(verifySuccess);

              _this64.eventHub.$emit('edit', false);

              var success = Object.values(dataErrors).reduce(function (prev, curr) {
                return prev.concat(curr);
              }, []);

              if (!success.length) {
                _this64.eventHub.$emit("alert:success:open");
              } else {
                _this64.setErrors(dataErrors);
              }
            }
          }, 1000);
        }
      }
    },
    mounted: function mounted() {
      var _this65 = this;

      $.ajaxSetup({
        traditional: true
      });
      this.init();
      this.eventHub.$on("go:to", function (name, error) {
        return _this65.goToSection(name, error);
      });
      this.eventHub.$on('edit', function (edit) {
        return _this65.isFormLoading = edit;
      });
      this.lawyerHub.$on('change', function (name, value) {
        return _this65.changes(name, value);
      });
      this.mustShowWarning = !localStorage.getItem('my-account-warning');
    },
    computed: {
      lawyerImg: function lawyerImg() {
        return 'background-image: url("' + (this.lawyer.thumbnail ? this.lawyer.thumbnail : '/static/img/no-avatar.png') + '")';
      },
      toSave: function toSave() {
        var _this66 = this;

        var obj = {
          lawyer: this.lawyer
        },
            postulations = this.postulations.filter(function (p) {
          return _this66.checkStatus(p, true);
        }),
            degrees = this.degrees.filter(function (p) {
          return _this66.checkStatus(p, true);
        }),
            social_networks = this.social_networks.filter(function (p) {
          return _this66.checkStatus(p, true);
        });

        if (postulations.length) {
          obj['postulations'] = postulations;
        }

        if (degrees.length) {
          obj['degrees'] = degrees;
        }

        if (social_networks.length) {
          obj['social_networks'] = social_networks;
        }

        return obj;
      }
    }
  });
}

if (document.getElementById("app_form_article")) {
  var vueFormArticle = new Vue({
    delimiters: ['[[', ']]'],
    mixins: [eventMixin],
    el: '#app_form_article',
    data: {
      id: null,
      author: '',
      successUrl: '',
      contentType: '',
      csrf: '',
      article: {
        tags: [],
        groups: [],
        published_date: ""
      },
      publishDate: "",
      eventDateStart: "",
      eventHourStart: "",
      eventDateEnd: "",
      eventHourEnd: "",
      categories: [],
      attachments: [],
      errors: [],
      isFormLoading: false,
      isCategoriesLoading: false,
      isFormSuccess: false,
      isImageLoading: false,
      attachmentTabActive: 1
    },
    watch: {
      publishDate: function publishDate(data) {
        var date = data.split('/').reverse().join('-');
        this.article.published_date = date;
      },
      dateStart: function dateStart(data) {
        this.article.event_date_start = data;
      },
      dateEnd: function dateEnd(data) {
        this.article.event_date_end = data;
      }
    },
    computed: {
      dateStart: function dateStart() {
        if (!this.eventDateStart) {
          return null;
        }

        var date = this.eventDateStart.split('/').reverse().join('-'),
            hour = this.eventHourStart;

        if (hour && hour.indexOf(':') == -1) {
          hour += ':00';
        }

        console.log(hour);
        return date + (hour ? 'T' + hour : '');
      },
      dateEnd: function dateEnd() {
        if (!this.eventDateEnd) {
          return null;
        }

        var date = this.eventDateEnd.split('/').reverse().join('-'),
            hour = this.eventHourEnd;

        if (hour && hour.indexOf(':') == -1) {
          hour += ':00';
        }

        console.log(hour);
        return date + (hour ? 'T' + hour : '');
      },
      submitOptions: function submitOptions() {
        var urlApi = '/api/v1/articles';
        return {
          url: this.id ? urlApi + '/' + this.id : urlApi,
          method: this.id ? "PUT" : "POST"
        };
      }
    },
    methods: {
      CKEditor: function CKEditor() {
        CKEDITOR.replace('content', {
          customConfig: confCKeditorBlog
        });
      },
      init: function init() {
        var article = this.$refs.article,
            id = article.getAttribute('data-id');

        if (id) {
          this.getArticle(id);
        } else {
          this.CKEditor();
        } //DATAS


        this.successUrl = article.getAttribute('data-successUrl');
        this.csrf = article.getAttribute('data-csrf');
        this.contentType = article.getAttribute('data-contentType');
        this.author = article.getAttribute('data-author');
      },
      setDates: function setDates() {
        this.publishDate = this.article.published_date.split('-').reverse().join('/');

        if (this.article.event_date_start) {
          var start = this.article.event_date_start.split('T'),
              startHour = start[1].split('.');
          this.eventDateStart = start[0].split('-').reverse().join('/');
          this.eventHourStart = startHour[0];
        }

        if (this.article.event_date_end) {
          var end = this.article.event_date_end.split('T'),
              endHour = end[1].split('.');
          this.eventDateEnd = end[0].split('-').reverse().join('/');
          this.eventHourEnd = endHour[0];
        }
      },
      removeError: function removeError(key) {
        if (this.errors.hasOwnProperty(key)) {
          delete this.errors[key];
        }
      },
      getArticle: function getArticle(id) {
        var _this67 = this;

        this.id = id;
        $.ajax({
          url: '/api/v1/articles/' + this.id,
          headers: {
            'Accept-Language': languageCode
          },
          method: 'GET',
          success: function success(response) {
            _this67.article = response;

            _this67.setDates();

            _this67.getCategories();

            _this67.getAttachments();

            _this67.CKEditor();

            console.log(response);
          },
          error: function error(_error8) {
            return _this67.eventHub.$emit("alert:error:open");
          }
        });
      },
      deleteArticle: function deleteArticle() {
        var that = this;
        $.ajax({
          url: '/api/v1/articles/' + this.id,
          type: 'DELETE',
          success: function success(response) {
            window.location.href = that.successUrl;
          },
          error: function error(_error9) {
            new Alert().warning();
          }
        });
      },
      updateImage: function updateImage(e) {
        var that = this,
            data = e.target,
            formData = new FormData();
        formData.append('image', data.files[0]);
        formData.append('attachment', data.files[0]);
        formData.append("csrfmiddlewaretoken", this.csrf);
        $.ajax({
          url: '/api/v1/medias',
          type: 'POST',
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function beforeSend() {
            that.isImageLoading = true;
          },
          success: function success(response) {
            new Alert().success();
            that.isImageLoading = false;
            that.setImage(response);
          },
          error: function error(_error10) {
            new Alert().warning();
            that.isImageLoading = false;
          }
        });
      },
      setImage: function setImage(data) {
        this.article.image = data.id;
        this.article.image_obj = data;
      },
      addTag: function addTag() {
        var tag = this.$refs.tag.value;
        this.article.tags.push(tag);
        this.$refs.tag.value = '';
      },
      deleteTag: function deleteTag(index) {
        this.article.tags.splice(index, 1);
      },
      getCategories: function getCategories() {
        this.categories = [];
        this.removeError("category");
        var params = [],
            that = this;

        if (this.article.is_public) {
          params.push('public');
        }

        if (this.article.is_private) {
          params.push('private');
        }

        if (!params.length) {
          this.article.category = null;
          return;
        }

        this.isCategoriesLoading = true;
        $.ajax({
          url: '/api/v1/categories_articles?display=' + params.join('-'),
          method: 'GET',
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            that.isCategoriesLoading = false;
            that.setCategories(response.results);
          },
          error: function error(_error11) {
            new Alert().warning();
          }
        });
      },
      setCategories: function setCategories(results) {
        var _this68 = this;

        this.categories = results;
        var found = this.categories.find(function (r) {
          return r.id == _this68.article.category;
        });

        if (!found) {
          this.article.category = !this.categories.length ? null : this.categories[0].id;
        }
      },
      isAttachmentDisabled: function isAttachmentDisabled() {
        if (!this.article.title || !this.article.category || !this.article.published_date) {
          return true;
        }

        return false;
      },
      getAttachments: function getAttachments() {
        var urlApi = '/api/v1/attachments?editing=1&content_type=' + this.contentType + '&object_id=' + this.id,
            that = this;
        $.ajax({
          url: urlApi,
          method: 'GET',
          success: function success(response) {
            that.setAttachments(response.results);
          },
          error: function error(_error12) {
            new Alert().warning();
          }
        });
      },
      setAttachments: function setAttachments(results) {
        this.attachments = results;
      },
      addAttachment: function addAttachment(data) {
        this.attachments.push(data);
      },
      deleteAttachment: function deleteAttachment(id) {
        var that = this;
        $.ajax({
          url: '/api/v1/attachments/' + id,
          type: 'DELETE',
          success: function success(response) {
            that.attachments = that.attachments.filter(function (a) {
              return a.id != id;
            });
          },
          error: function error(_error13) {
            new Alert().warning();
          }
        });
      },
      submit: function submit(e, callback) {
        e.preventDefault();

        var that = this,
            CKContent = CKEDITOR.instances['content'].getData(),
            data = _objectSpread({}, that.article, {
          author: this.author,
          content: CKContent
        });

        this.errors = [];
        $.ajax({
          url: that.submitOptions.url,
          type: that.submitOptions.method,
          data: JSON.stringify(data),
          cache: false,
          contentType: 'application/json',
          processData: false,
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            if (callback) {
              that.article = response;
              that.id = response.id;
              callback();
              return;
            }

            that.isFormSuccess = true;
            setTimeout(function () {
              that.isFormSuccess = false;
              that.article = response;

              if (!that.id) {
                window.location.replace(that.successUrl);
              }

              that.id = response.id;
            }, 2000);
          },
          error: function error(_error14) {
            that.errors = _error14.responseJSON;
            new Alert().error();
          }
        });
      }
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
      this.init();
    }
  });

  (function ($) {
    $.fn.typeAttachment = function () {
      var select = $(this).find('.js-select');
      select.on('change', function () {
        if ($(this).find('option:selected').data('slug') !== 'videos' && $(this).find('option:selected').data('slug') !== 'video') {
          var $target = $('[data-tab="tab_1"]'),
              $currentItem = $('.js-tab-toggle[data-target="1"]');
          $('.js-tab-toggle[data-target="2"]').removeClass('active').hide();
          $currentItem.addClass('active').show();
          $('.js-tab-item').find('input').attr('required', false);
          $target.find('input').attr('required', true);
          setTimeout(function () {
            $('.js-tab-item').hide();
            $target.show();
            setTimeout(function () {
              $target.addClass('left');
              $target.addClass('active').removeClass('left right');
            }, 50);
          }, 150);
          $('.js-underline').css({
            'width': $currentItem.width()
          });
        } else {
          var $target = $('[data-tab="tab_2"]'),
              $currentItem = $('.js-tab-toggle[data-target="2"]');
          $('.js-tab-item').find('input').attr('required', false);
          $target.find('input').attr('required', true);
          $currentItem.addClass('active').show();
          $('.js-tab-toggle[data-target="1"]').removeClass('active').hide();
          $currentItem.css({
            'padding-left': 0
          });
          $('.js-underline').css({
            'width': $currentItem.width(),
            'left': $currentItem.position().left
          });
          setTimeout(function () {
            $('.js-tab-item').hide();
            $target.show();
            setTimeout(function () {
              $target.addClass('right');
              $target.addClass('active').removeClass('left right');
            }, 50);
          }, 150);
        }
      });
    }, $.fn.addAttachment = function () {
      var input = $(this).find('.js-attachment-input'),
          filename = $(this).find('.js-filename'),
          fileData = '';
      input.on('change', function (e) {
        var fileName = e.target.files[0].name;
        fileData = e.target.files[0];
        filename.text(fileName);
      });
    };

    var sendAttachment = function sendAttachment(target) {
      var that = target;

      if (!that.classList.contains('form-is-updating')) {
        that.classList.add('form-is-updating');
        var formData = new FormData($(target)[0]);

        if ($(target).find('.js-tab-toggle.active').attr('data-target') == 1) {
          formData.append('title', $('#attachment_title').val());
          formData.append('file', $('#uploadAttachment').find('.js-attachment-input')[0].files[0]);
        }

        if ($(target).find('.js-tab-toggle.active').attr('data-target') == 2) {
          formData.append('title', $('#attachment_video_title').val());
          formData.append('video_id', $('#attachment_video_url').val());
        }

        formData.append('rubric', 2);
        formData.append('file_type', parseInt($('#type_attachment').find('option:selected').data('id')));
        formData.append('content_type', parseInt(vueFormArticle.contentType));
        formData.append('object_id', parseInt(vueFormArticle.id));
        setTimeout(function () {
          $.ajax({
            url: '/api/v1/attachments',
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function success(response) {
              that.classList.remove('form-is-updating');
              $('#uploadAttachment').removeClass('is-open');
              $('.js-modal-error').hide();
              vueFormArticle.addAttachment(response);
              new Alert().success();
              return false;
            },
            error: function error(_error15) {
              var errorText = _error15.responseJSON.file[0];
              var errors = _error15.responseJSON;

              for (_error15 in errors) {
                $('.js-form-upload').find('.js-tab-item.active').find('[data-error="' + _error15 + '"]').addClass('has-error');
              }

              $('.js-modal-error').text(errorText);
              $('.js-modal-error').show();
            }
          });
        }, 1000);
      }
    };

    $.fn.initAttachment = function () {
      $(this).on('submit', function (e) {
        var that = this;
        e.preventDefault();

        if (vueFormArticle.id) {
          sendAttachment(that);
        } else {
          vueFormArticle.submit(e, function () {
            return sendAttachment(that);
          });
        }
      });
    };
  })(jQuery);

  $(function () {
    if ($('.js-add-attachment-article').length) {
      $('.js-form-upload').initAttachment();
      $('.js-add-attachment-article').on('click', function () {
        $('#uploadAttachment').addAttachment();
        $('.js-form-upload').typeAttachment();
      });
    }
  });
}

if (document.getElementById("app_form_estate")) {
  var vueFormEstate = new Vue({
    delimiters: ['[[', ']]'],
    el: '#app_form_estate',
    data: {
      id: null,
      author: '',
      successUrl: '',
      contentType: '',
      csrf: '',
      estate: {
        is_published: false,
        published_date: '',
        images: [],
        images_obj: []
      },
      publishDate: '',
      attachments: [],
      audienceDate: '',
      audienceHour: '',
      isFormSuccess: false,
      errors: [],
      isImageLoading: false,
      categories: [{
        id: "vente",
        name: "Vente"
      }, {
        id: "vente-aux-encheres",
        name: "Vente aux enchères"
      }, {
        id: "location",
        name: "Location"
      }, {
        id: "vente-fond-de-commerce",
        name: "Vente fond de commerce"
      }, {
        id: "vente-en-viager",
        name: "Vente en viager"
      }]
    },
    watch: {
      publishDate: function publishDate(data) {
        this.estate.published_date = data;
      },
      audience: function audience(data) {
        this.estate.audience = data;
      }
    },
    computed: {
      audience: function audience() {
        if (!this.audienceDate) {
          return null;
        }

        var date = this.audienceDate.split('/').reverse().join('-');
        return date + 'T' + this.audienceHour;
      },
      submitOptions: function submitOptions() {
        var urlApi = '/api/v1/estate';
        return {
          url: this.id ? urlApi + '/' + this.id : urlApi,
          method: this.id ? "PUT" : "POST"
        };
      }
    },
    mounted: function mounted() {
      $.ajaxSetup({
        traditional: true
      });
      this.init();
    },
    methods: {
      isAttachmentDisabled: function isAttachmentDisabled() {
        var department = $('.js-select-department').val();

        if (!this.estate.title || !this.estate.sale_number || !department || !this.estate.city || !this.estate.price || !this.estate.address) {
          return true;
        }

        return false;
      },
      CKEditor: function CKEditor() {
        CKEDITOR.replace('description', {
          customConfig: confCKeditorBlog
        });
      },
      init: function init() {
        var data = this.$refs.estate,
            id = data.getAttribute('data-id');

        if (id) {
          this.get(id);
        } else {
          this.CKEditor();
        }

        this.successUrl = data.getAttribute('data-successUrl');
        this.csrf = data.getAttribute('data-csrf');
        this.contentType = data.getAttribute('data-contentType');
        this.author = data.getAttribute('data-author');
      },
      setDates: function setDates() {
        if (this.estate.audience) {
          var date = this.estate.audience.split('T'),
              hour = date[1].split('.');
          this.audienceDate = date[0].split('-').reverse().join('/');
          this.audienceHour = hour[0];
        }
      },
      setDepartment: function setDepartment(data) {
        this.estate.department = data;
        this.isAttachmentDisabled();
      },
      setType: function setType(data) {
        this.estate.estate_type = data;
      },
      removeError: function removeError(key) {
        if (this.errors.hasOwnProperty(key)) {
          delete this.errors[key];
        }
      },
      get: function get(id) {
        var _this69 = this;

        this.id = id;
        $.ajax({
          url: '/api/v1/estate/' + this.id,
          headers: {
            'Accept-Language': languageCode
          },
          method: 'GET',
          success: function success(response) {
            _this69.estate = response;

            _this69.setDates();

            _this69.getAttachments();

            _this69.CKEditor();
          },
          error: function error(_error16) {
            return _this69.eventHub.$emit("alert:error:open");
          }
        });
      },
      deleteEstate: function deleteEstate() {
        var that = this;
        $.ajax({
          url: '/api/v1/estate/' + this.id,
          type: 'DELETE',
          success: function success(response) {
            window.location.href = that.successUrl;
          },
          error: function error(_error17) {
            new Alert().warning();
          }
        });
      },
      setImage: function setImage(data) {
        if (this.id) {
          this.saveImage(data.id);
        } else {
          this.estate.images.push(data.id);
          this.estate.images_obj.push(data);
        }
      },
      getImageUrl: function getImageUrl(image) {
        return image.hasOwnProperty('thumbnail_url') ? image.thumbnail_url : image.image_obj.thumbnail_url;
      },
      saveImage: function saveImage(id, newId) {
        var that = this,
            dataImages = {
          "estate_ad": newId ? newId : this.id,
          "image": id
        };
        $.ajax({
          url: '/api/v1/estate_images',
          type: 'POST',
          data: JSON.stringify(dataImages),
          contentType: 'application/json',
          processData: false,
          success: function success(response) {
            if (!newId) {
              that.estate.images.push(response.id);
              that.estate.images_obj.push(response);
            } else {
              that.estate.images.indexOf(id, 1, response.id);
              that.estate.images_obj = that.estate.images_obj.map(function (i) {
                return i.id == id ? response : i;
              });
            }
          },
          error: function error(_error18) {
            new Alert().warning();
            console.log(_error18);
          }
        });
      },
      addImage: function addImage(e) {
        var that = this,
            data = e.target,
            formData = new FormData();
        formData.append('image', data.files[0]);
        formData.append('attachment', data.files[0]);
        formData.append("csrfmiddlewaretoken", this.csrf);
        $.ajax({
          url: '/api/v1/medias',
          type: 'POST',
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function beforeSend() {
            that.isImageLoading = true;
          },
          success: function success(response) {
            new Alert().success();
            that.isImageLoading = false;
            that.setImage(response);
          },
          error: function error(_error19) {
            new Alert().warning();
            that.isImageLoading = false;
          }
        });
      },
      removeImage: function removeImage(id) {
        this.isImageLoading = true;
        this.estate.images_obj = this.estate.images_obj.map(function (i) {
          if (i.id == id) {
            i['is_removed'] = true;
          }

          return i;
        });

        if (this.id) {
          this.deleteImage(id);
        } else {
          this.deleteMedia(id);
        }
      },
      deleteImage: function deleteImage(id) {
        var that = this;
        $.ajax({
          url: '/api/v1/estate_images/' + id,
          method: 'DELETE',
          success: function success(response) {
            that.deleteMedia(id);
          },
          error: function error(_error20) {
            new Alert().warning();
            that.isImageLoading = false;
          }
        });
      },
      deleteMedia: function deleteMedia(id) {
        var that = this;
        $.ajax({
          url: '/api/v1/medias/' + id,
          method: 'DELETE',
          success: function success(response) {
            that.estate.images = that.estate.images.filter(function (a) {
              return a != id;
            });
            that.estate.images_obj = that.estate.images_obj.filter(function (a) {
              return a.id != id;
            });
            that.isImageLoading = false;
          },
          error: function error(_error21) {
            new Alert().warning();
            that.isImageLoading = false;
          }
        });
      },
      getAttachments: function getAttachments() {
        var urlApi = '/api/v1/attachments?editing=1&content_type=' + this.contentType + '&object_id=' + this.id,
            that = this;
        $.ajax({
          url: urlApi,
          method: 'GET',
          success: function success(response) {
            that.setAttachments(response.results);
          },
          error: function error(_error22) {
            new Alert().warning();
          }
        });
      },
      setAttachments: function setAttachments(results) {
        this.attachments = results;
      },
      addAttachment: function addAttachment(data) {
        this.attachments.push(data);
      },
      deleteAttachment: function deleteAttachment(id) {
        var that = this;
        $.ajax({
          url: '/api/v1/attachments/' + id,
          type: 'DELETE',
          success: function success(response) {
            that.attachments = that.attachments.filter(function (a) {
              return a.id != id;
            });
          },
          error: function error(_error23) {
            new Alert().warning();
          }
        });
      },
      save: function save(response, callback) {
        var _this70 = this;

        if (callback) {
          this.estate = response;
          this.id = response.id;
          callback();
          return;
        }

        this.isFormSuccess = true;
        setTimeout(function () {
          _this70.isFormSuccess = false;
          _this70.estate = response;

          if (!_this70.id) {
            window.location.replace(_this70.successUrl);
          }

          _this70.id = response.id;
        }, 2000);
      },
      submit: function submit(e, callback) {
        e.preventDefault();

        var that = this,
            CKContent = CKEDITOR.instances['description'].getData(),
            data = _objectSpread({}, that.estate, {
          images: this.id ? this.estate.images : [],
          lawyer: this.author,
          description: CKContent
        });

        this.errors = [];
        $.ajax({
          url: that.submitOptions.url,
          type: that.submitOptions.method,
          data: JSON.stringify(data),
          cache: false,
          contentType: 'application/json',
          processData: false,
          headers: {
            'Accept-Language': languageCode
          },
          success: function success(response) {
            if (!that.id && that.estate.images.length && !callback) {
              that.estate.images.forEach(function (i, index) {
                that.saveImage(i, response.id);

                if (index + 1 == that.estate.images.length) {
                  that.save(Object.assign(response, {
                    images: that.estate.images,
                    images_obj: that.estate.images_obj
                  }), callback);
                }
              });
            } else {
              that.save(response, callback);
            }
          },
          error: function error(_error24) {
            that.errors = _error24.responseJSON;
            new Alert().error();
          }
        });
      }
    }
  });

  (function ($) {
    $.fn.typeAttachment = function () {
      var select = $(this).find('.js-select');
      select.on('change', function () {
        if ($(this).find('option:selected').data('slug') !== 'videos' && $(this).find('option:selected').data('slug') !== 'video') {
          var $target = $('[data-tab="tab_1"]'),
              $currentItem = $('.js-tab-toggle[data-target="1"]');
          $('.js-tab-toggle[data-target="2"]').removeClass('active').hide();
          $currentItem.addClass('active').show();
          $('.js-tab-item').find('input').attr('required', false);
          $target.find('input').attr('required', true);
          setTimeout(function () {
            $('.js-tab-item').hide();
            $target.show();
            setTimeout(function () {
              $target.addClass('left');
              $target.addClass('active').removeClass('left right');
            }, 50);
          }, 150);
          $('.js-underline').css({
            'width': $currentItem.width()
          });
        } else {
          var $target = $('[data-tab="tab_2"]'),
              $currentItem = $('.js-tab-toggle[data-target="2"]');
          $('.js-tab-item').find('input').attr('required', false);
          $target.find('input').attr('required', true);
          $currentItem.addClass('active').show();
          $('.js-tab-toggle[data-target="1"]').removeClass('active').hide();
          $currentItem.css({
            'padding-left': 0
          });
          $('.js-underline').css({
            'width': $currentItem.width(),
            'left': $currentItem.position().left
          });
          setTimeout(function () {
            $('.js-tab-item').hide();
            $target.show();
            setTimeout(function () {
              $target.addClass('right');
              $target.addClass('active').removeClass('left right');
            }, 50);
          }, 150);
        }
      });
    }, $.fn.addAttachment = function () {
      var input = $(this).find('.js-attachment-input'),
          filename = $(this).find('.js-filename'),
          fileData = '';
      input.on('change', function (e) {
        var fileName = e.target.files[0].name;
        fileData = e.target.files[0];
        filename.text(fileName);
      });
    };

    var sendAttachment = function sendAttachment(target) {
      var that = target;

      if (!that.classList.contains('form-is-updating')) {
        that.classList.add('form-is-updating');
        var formData = new FormData($(target)[0]);

        if ($(target).find('.js-tab-toggle.active').attr('data-target') == 1) {
          formData.append('title', $('#attachment_title').val());
          formData.append('file', $('#uploadAttachment').find('.js-attachment-input')[0].files[0]);
        }

        if ($(target).find('.js-tab-toggle.active').attr('data-target') == 2) {
          formData.append('title', $('#attachment_video_title').val());
          formData.append('video_id', $('#attachment_video_url').val());
        }

        formData.append('rubric', 2);
        formData.append('file_type', parseInt($('#type_attachment').find('option:selected').data('id')));
        formData.append('content_type', parseInt(vueFormEstate.contentType));
        formData.append('object_id', parseInt(vueFormEstate.id));
        setTimeout(function () {
          $.ajax({
            url: '/api/v1/attachments',
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            success: function success(response) {
              that.classList.remove('form-is-updating');
              $('#uploadAttachment').removeClass('is-open');
              $('.js-modal-error').hide();
              vueFormEstate.addAttachment(response);
              new Alert().success();
              return false;
            },
            error: function error(_error25) {
              var errorText = _error25.responseJSON.file[0];
              var errors = _error25.responseJSON;

              for (_error25 in errors) {
                $('.js-form-upload').find('.js-tab-item.active').find('[data-error="' + _error25 + '"]').addClass('has-error');
              }

              $('.js-modal-error').text(errorText);
              $('.js-modal-error').show();
            }
          });
        }, 1000);
      }
    };

    $.fn.initAttachment = function () {
      $(this).on('submit', function (e) {
        var that = this;
        e.preventDefault();

        if (vueFormEstate.id) {
          sendAttachment(that);
        } else {
          vueFormEstate.submit(e, function () {
            return sendAttachment(that);
          });
        }
      });
    };
  })(jQuery);

  $(function () {
    if ($('.js-add-attachment-article').length) {
      $('.js-form-upload').initAttachment();
      $('.js-add-attachment-article').on('click', function () {
        $('#uploadAttachment').addAttachment();
        $('.js-form-upload').typeAttachment();
      });
      $('.js-select-department').on('change', function (e) {
        return vueFormEstate.setDepartment(e.target.value);
      });
      $('.js-select-type').on('change', function (e) {
        return vueFormEstate.setType(e.target.value);
      });
    }
  });
}